<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2022-09-20 14:37:58
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2023-07-07 10:57:23
 * @FilePath: /WeMeet_admin_project/wemeet-admin/src/App.vue
 * @Description: 
 * Copyright (c) 2023 by WeMeet, All Rights Reserved. 
-->
<template>
  <vab-app />
</template>

<script>
  import { defineComponent, computed } from 'vue'

  export default defineComponent({
    name: 'App',
  })
</script>
<style>
  @import url('./assets/css/common.css');
</style>
